module.exports = __webpack_public_path__ + "img/award-prize-02.2dbb815e.png";